import { memo } from 'react';
import PropTypes from 'prop-types';
import { MdDirectionsWalk, MdDirectionsCar } from 'react-icons/md';
import NumberFormat from 'react-number-format';
import clsx from 'clsx';

const DistanceFromLocationLabel = ({
  distance,
  label,
  headingLabel,
  className,
  parentClassName,
  walkingDistance,
  labelClassName,
  valueClassName,
}) => {
  const doHaveDriveDistance = distance !== null && distance !== undefined;
  const doHaveWalkDistance = walkingDistance !== null && walkingDistance !== undefined;
  if ((!doHaveDriveDistance && !doHaveWalkDistance) || !label) return '';

  return (
    <>
      {headingLabel && distance ? (
        <div className={(labelClassName || parentClassName)}>
          {headingLabel}
        </div>
      ) : <div />}
      <div className={valueClassName || parentClassName}>
        {doHaveDriveDistance && distance >= 0 ? (
          <>
            <MdDirectionsCar size="20" className={clsx('inline-block -mt-1', className)} title="Driving distance" />
            <NumberFormat
              value={distance}
              displayType="text"
              decimalScale={2}
            />
          </>
        ) : <></>}
        {doHaveWalkDistance && walkingDistance >= 0 ? (
          <>
            {doHaveDriveDistance && distance >= 0 && (
              <>
                {' '}
                miles /
              </>
            )}
            <MdDirectionsWalk size="20" className={clsx('inline-block -mt-1', className)} title="Walking distance" />
            <NumberFormat
              value={walkingDistance}
              displayType="text"
              className="ml-2"
              decimalScale={2}
            />
          </>
        ) : <></>}
        {' '}
        miles from
        {' '}
        {label}
      </div>
    </>
  );
};
DistanceFromLocationLabel.propTypes = {
  distance: PropTypes.number,
  walkingDistance: PropTypes.number,
  label: PropTypes.string,
  headingLabel: PropTypes.string,
  className: PropTypes.string,
  parentClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  valueClassName: PropTypes.string,
};

DistanceFromLocationLabel.defaultProps = {
  distance: null,
  walkingDistance: null,
  label: null,
  headingLabel: null,
  className: '',
  parentClassName: '',
  labelClassName: '',
  valueClassName: '',
};

export default memo(DistanceFromLocationLabel);
